import create from "zustand";
import { isType } from "@mqd/volt-toolbox/src";
export const defaultVoltState = {
  loading: false,
  leftNav: {
    show: false,
    showHeader: true,
    pinned: true,
    menus: {}
  },
  go: null,
  dom: {
    topBar: null,
    leftNav: null,
    content: null
  }
};
export const useVoltState = create((set, get) => ({
  ...defaultVoltState,
  toggleLoading: (value) => set((state) => ({
    loading: isType(value, "boolean") ? value : !state.loading
  })),
  setLeftNav: (leftNav = {}) => set((state) => ({
    leftNav: {
      ...state.leftNav,
      ...leftNav
    }
  })),
  setDom: (dom = {}) => set((state) => ({
    dom: {
      ...state.dom,
      ...dom
    }
  })),
  toggleLeftNav: (value) => set((state) => ({
    leftNav: {
      ...state.leftNav,
      pinned: isType(value, "boolean") ? value : !state.leftNav.pinned
    }
  })),
  toggleLeftNavHeader: (value) => set((state) => ({
    leftNav: {
      ...state.leftNav,
      showHeader: isType(value, "boolean") ? value : !state.leftNav.showHeader
    }
  })),
  setGo: (go) => set((state) => ({ go })),
  reset: () => set({ ...defaultVoltState })
}));
